export default __webpack_public_path__ + "static/media/bitcoin-mane.b224a505.svg";